{
  "Back": "Atrás",
  "Invoice": "Factura",
  "Payment Due": "Pago Vencido",
  "Paid": "Pagado",
  "Download PDF": "Descargar PDF",
  "Pay Invoice": "Pagar Factura",
  "Invoice Date": "Fecha de Factura",
  "Due Date": "Fecha de Vencimiento",
  "Auto-Pay On": "Pago Automático Activado",
  "Auto-Pay Off": "Pago Automático Desactivado",
  "Invoice Total": "Total de la Factura",
  "Balance due": "Saldo Pendiente",
  "Bill To": "Facturar a",
  "Account Number": "Número de Cuenta",
  "Account Balance": "Saldo de la Cuenta",
  "Bill From": "Facturado por",
  "Check payment instructions": "Instrucciones para el pago con cheque",
  "If paying via check": "Si paga mediante cheque, hágalo a nombre de {{recipient}}, incluya su número de cuenta ({{accountNumber}}) y el ID de ubicación ({{locationId}}) en la sección 'memo', e incluya una copia de esta factura con su cheque:",
  "USPS": "Si envía por correo estándar de USPS, envíelo a Industrious Office, P.O. Box 780441, Philadelphia PA 19178-0441.",
  "courier": "Si envía por mensajería o servicio exprés, envíelo a Wells Fargo Lockbox Services, Industrious Office, Lockbox – 780441, MAC: Y1372-045, 401 Market Street, Philadelphia PA 19106.",
  "Payment is due on the invoice due date": "El pago debe realizarse en la fecha de vencimiento de la factura. Se aplicará una tarifa de demora del 10% a cualquier saldo pendiente que supere los 5 días después de la fecha de vencimiento. Si ya está inscrito en pago automático por débito ACH o tarjeta de crédito, Industrious cobrará a su cuenta en la fecha de vencimiento de la factura y no se requerirá ninguna acción.",
  "To the extent applicable": "En la medida en que sea aplicable a los servicios prestados o a la licencia otorgada a usted y en la medida en que las responsabilidades de Industrious estén limitadas, los Términos de Uso y la Política de Privacidad de Industrious, ubicados en",
  "incorporated": "se incorporan por referencia y rigen nuestro acuerdo como si usted fuera miembro y licenciatario del espacio de oficina de Industrious. El pago constituye la aceptación de todos los términos de esta factura por su parte.",
  "Please contact billing@industriousoffice.com with any questions regarding your invoice.": "Por favor, contacte con billing@industriousoffice.com si tiene alguna pregunta sobre su factura.",
  "MAC": "MAC: Y1372-045, 401 Market Street, Philadelphia PA 19106.",
  "Applied Credit": "Crédito Aplicado",
  "As of {{date}}, this invoice is not scheduled for auto-pay.": "A partir de {{date}}, esta factura no está programada para pago automático.",
  "As of {{date}}, this invoice is scheduled for auto-pay.": "A partir de {{date}}, esta factura está programada para pago automático.",
  "Item": "Artículo",
  "Description": "Descripción",
  "Service Period": "Período de Servicio",
  "Unit Price": "Precio Unitario",
  "Quantity": "Cantidad",
  "Amount": "Monto"
}
